import React, { useRef, memo, useCallback, useEffect, useState } from "react";

import LeftSideEditProfile from "./../LeftSideEditProfile";
import { Title } from "./../videoPhoto/Component";

import coacheImg1 from "./../assets/img/event_default.png";
import trashIcon from "./../assets/img/trash-icon.svg";
import pencilIcon from "./../assets/img/pencil-icon.svg";
import VerificationIcon from "./../assets/img/complete-verification-icon.svg";
import Dialog from "@mui/material/Dialog";
import closeGrayIcon from "../assets/img/close-gray-icon.svg";
import trashCircleIcon from "../assets/img/trash-circle-icon.svg";
import {connect, useDispatch, useSelector} from "react-redux";
import {
  schoolTeamUserMappingSave,
  schoolTeamUserMappingStart,
} from "../../../../../../redux/athlete/dashboard/editUserProfile/schoolTeamUserMapping";
import {
  getSchoolTeamUserMappingForCoaches,
  getSchoolTeamUserMappingForTeams,
  updateSchoolTeamMapping,
} from "./TeamQuery";
import { getUserInfo } from "../../../../../../services/authService";
import { fetchGraphMethod } from "../../../../../../services/httpService";
import { data } from "jquery";
import { useHistory } from "react-router";
import BackdropLoader from "../../../../../common/Loader";
import { Checkbox } from "@mui/material";
import messagePopup from "../../../../../../utils/messagePopup";
import toastr from "toastr";
import { deleteSchoolTeamStart } from "../../../../../../redux/athlete/dashboard/editUserProfile/deleteSchoolTeam";
import ScreenSwitch from "../ScreenSwitch";
import GoTopButton from '../GoTopButton';
import VerificationModal from "../VerificationModal";
import {imageDownloadUrl} from "../../../../../../config";

const SubHeader = ({ onSideMenuClick }) => {
  const [showVerificationModalState, setShowVerificationModalState] =
      useState(false);

  const showVerificationModal = () => {
    setShowVerificationModalState(!showVerificationModalState);
  };

  return (
    <div className="subHeader">
      <div className="menu">
        <button onClick={onSideMenuClick}>
          <span></span> Edit Profile
        </button>
      </div>
      {JSON.parse(localStorage.getItem('user')).verifiedUserStatus === 1 ? 
      <div className="profile-verified-text">
                   <span className="verifiedIcon">
                   <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26.418"
                          height="26.403"
                          viewBox="0 0 26.418 26.403"
                        >
                          <defs>
                            <style></style>
                          </defs>
                          <path
                            className="a"
                            d="M-4229.021-6663.778a1.151,1.151,0,0,1-.986-.543,1.174,1.174,0,0,0-.993-.543,1.174,1.174,0,0,0-.993.543,1.151,1.151,0,0,1-.986.543,1.169,1.169,0,0,1-1.152-.9v-.005a1.179,1.179,0,0,0-1.149-.9,1.16,1.16,0,0,0-.728.256,1.169,1.169,0,0,1-.729.259,1.2,1.2,0,0,1-.883-.392,1.158,1.158,0,0,1-.3-.9l0-.013a1.161,1.161,0,0,0-.3-.9,1.184,1.184,0,0,0-.87-.387,1.181,1.181,0,0,0-.395.068h-.005a1.189,1.189,0,0,1-.4.07,1.175,1.175,0,0,1-.984-.544,1.155,1.155,0,0,1-.084-1.116l.01-.021a1.174,1.174,0,0,0-.088-1.121,1.175,1.175,0,0,0-.989-.538h-.033a1.163,1.163,0,0,1-1.08-.708,1.164,1.164,0,0,1,.219-1.274l.019-.019a1.171,1.171,0,0,0,.28-1.09,1.176,1.176,0,0,0-.769-.831l-.02,0a1.164,1.164,0,0,1-.8-1.02,1.164,1.164,0,0,1,.621-1.138l.02-.01a1.174,1.174,0,0,0,.621-.943,1.172,1.172,0,0,0-.456-1.031l-.02-.017a1.161,1.161,0,0,1-.425-1.223,1.164,1.164,0,0,1,.957-.875l.017,0a1.174,1.174,0,0,0,.894-.688,1.172,1.172,0,0,0-.1-1.125l-.013-.021a1.159,1.159,0,0,1-.058-1.2,1.173,1.173,0,0,1,1.03-.625,1.229,1.229,0,0,1,.215.019h.008a1.234,1.234,0,0,0,.21.019,1.166,1.166,0,0,0,.928-.459,1.169,1.169,0,0,0,.207-1.017l0-.017a1.148,1.148,0,0,1,.2-1.012,1.2,1.2,0,0,1,.938-.467,1.169,1.169,0,0,1,.572.151,1.16,1.16,0,0,0,.571.15,1.186,1.186,0,0,0,1.177-1.092v-.01a1.176,1.176,0,0,1,1.184-1.092,1.158,1.158,0,0,1,.866.39,1.159,1.159,0,0,0,.871.39,1.18,1.18,0,0,0,1.086-.715,1.162,1.162,0,0,1,1.084-.717,1.162,1.162,0,0,1,1.084.715,1.18,1.18,0,0,0,1.086.717,1.159,1.159,0,0,0,.871-.39,1.158,1.158,0,0,1,.866-.39,1.176,1.176,0,0,1,1.184,1.092v.01a1.186,1.186,0,0,0,1.177,1.092,1.16,1.16,0,0,0,.569-.148,1.164,1.164,0,0,1,.574-.153,1.2,1.2,0,0,1,.938.467,1.148,1.148,0,0,1,.2,1.012l-.005.017a1.169,1.169,0,0,0,.207,1.017,1.166,1.166,0,0,0,.928.459,1.234,1.234,0,0,0,.21-.019h.008a1.229,1.229,0,0,1,.215-.019,1.172,1.172,0,0,1,1.029.625,1.158,1.158,0,0,1-.057,1.2l-.013.021a1.172,1.172,0,0,0-.1,1.125,1.174,1.174,0,0,0,.894.688l.017,0a1.164,1.164,0,0,1,.958.875,1.161,1.161,0,0,1-.425,1.222l-.021.017a1.173,1.173,0,0,0-.456,1.032,1.174,1.174,0,0,0,.621.943l.021.01a1.164,1.164,0,0,1,.621,1.138,1.164,1.164,0,0,1-.8,1.02l-.02,0a1.179,1.179,0,0,0-.769.831,1.171,1.171,0,0,0,.283,1.09l.016.019a1.164,1.164,0,0,1,.218,1.273,1.163,1.163,0,0,1-1.08.708h-.033a1.175,1.175,0,0,0-.989.538,1.174,1.174,0,0,0-.088,1.121l.01.021a1.154,1.154,0,0,1-.083,1.116,1.175,1.175,0,0,1-.984.544,1.185,1.185,0,0,1-.4-.07h-.005a1.181,1.181,0,0,0-.395-.068,1.184,1.184,0,0,0-.87.387,1.161,1.161,0,0,0-.3.9v.013a1.157,1.157,0,0,1-.3.9,1.2,1.2,0,0,1-.883.392,1.159,1.159,0,0,1-.727-.259,1.164,1.164,0,0,0-.729-.256,1.181,1.181,0,0,0-1.15.9v0A1.168,1.168,0,0,1-4229.021-6663.778Zm-7.2-15.261a.709.709,0,0,0-.522.232l-1.041,1.122a.835.835,0,0,0,0,1.12l4.787,5.15a.712.712,0,0,0,.522.231.71.71,0,0,0,.52-.231l8.471-9.111a.84.84,0,0,0,0-1.122l-1.041-1.12a.711.711,0,0,0-.522-.232.705.705,0,0,0-.521.232l-6.908,7.43-3.226-3.469A.706.706,0,0,0-4236.221-6679.039Z"
                            transform="translate(4244.209 6690.181)"
                          />
                        </svg>
                        </span>
        Congrats your profile is verified
      </div>  
      :<div className="profile-verified-text">
        <img
          className="icon"
          src={VerificationIcon}
          alt="Verified"
          onClick={showVerificationModal}
        />
        Your profile is not verified for college coaches.
        <a style={{"cursor":"pointer"}} onClick={()=>window.open('https://calendly.com/sportsforce/recruiting-assessment-round-robin','_blank')}>Complete Verification Now</a>
      </div>}
      <div className="save">
        {/* <button>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13.889"
            height="13.945"
            viewBox="0 0 13.889 13.945"
          >
            <g id="save" transform="translate(0 -0.001)">
              <path
                id="Path_2125"
                data-name="Path 2125"
                d="M13.38,2.1,11.793.508A1.736,1.736,0,0,0,10.565,0H9.548V3.038a.434.434,0,0,1-.434.434H2.17a.434.434,0,0,1-.434-.434V0H.868A.868.868,0,0,0,0,.868V13.021a.868.868,0,0,0,.868.868H13.021a.868.868,0,0,0,.868-.868v-9.7A1.736,1.736,0,0,0,13.38,2.1ZM12.153,12.153H1.736V6.944H12.153Z"
                transform="translate(0 0.058)"
                fill="#3e3e3e"
              />
              <rect
                id="Rectangle_416"
                data-name="Rectangle 416"
                width="2"
                height="3"
                transform="translate(5.457 0.001)"
                fill="#3e3e3e"
              />
            </g>
          </svg>
          Save
        </button> */}
      </div>
      <Dialog open={showVerificationModalState}
              onClose={(event, reason)=> {
                if (reason == "backdropClick" || reason == "escapeKeyDown") {
                  showVerificationModal()
                }
              }}
              className="matDialogCustom"
      >
        <VerificationModal
            onClose={showVerificationModal}
            // profileImage={fields.profileimagename}
        />
      </Dialog>
    </div>
  );
};
const DeleteItem = (props) => {
  const getTeamType = () => {
    let type = "";
    if (props.team.isSchool) {
      if (
        props.team.athleteschoolschooltypeidmaprel &&
        props.team.athleteschoolschooltypeidmaprel.Highschooltypes &&
        props.team.athleteschoolschooltypeidmaprel.Highschooltypes[0]
      ) {
        type =
          props.team.athleteschoolschooltypeidmaprel.Highschooltypes[0].type;
      }
    } else {
      if (
        props.team.teamteamtypeidmaprel &&
        props.team.teamteamtypeidmaprel.Schoolteamtypes &&
        props.team.teamteamtypeidmaprel.Schoolteamtypes[0]
      ) {
        type = props.team.teamteamtypeidmaprel.Schoolteamtypes[0].type;
      }
    }
    return type;
  };
  return (
    <div
      className="modal fade common-modal delete-modal coache-modal show"
      id="ReferenceTrashModal"
      style={{ display: "block" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <button
              type="button"
              className="close"
              onClick={props.onCancelClick}
            >
              <img src={closeGrayIcon} alt="close Gray Icon" />
            </button>
            <div className="icon-box-first">
              <img src={trashCircleIcon} alt="trash Circle Icon" />
            </div>
            <div className="connect-with-coaches-top-box">
              <div className="icon-box">
                <img src={coacheImg1} alt="coacheImg1" />
              </div>
              <div className="content-box">
                <h4>{props.team.highschoolname || props.team.teamname}</h4>
                <p>
                  {getTeamType()}{!!props.team.city ? ' in ' + props.team.city + ', '  : ''}{!!props.team.state ? props.team.state : ''}
                </p>
              </div>
            </div>
            <div className="short-content-box">
              <p>
                Deleting {props.team.highschoolname || props.team.teamname} will remove you from your coaches
                <br /> list of athletes waiting to be verified.
              </p>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn" onClick={props.onDeleteClick}>
              Delete
            </button>
            <button
              type="button"
              className="btn gray"
              onClick={props.onCancelClick}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
const EditSection = (props) => {
  let history = useHistory();
  const [teamAndCoachList, setTeamAndCoachList] = useState();
  const [loader, setLoader] = useState(false);
  const [showLess, setShowLess] = useState(true);
  useEffect(() => {
    let totalData =  [...props.teamAndCoachList]
    if (totalData?.length > 0){
      totalData?.map(async (coa, idx)=>{
        const finalObj =  coa?.isSchool ?
            {
              obj:{
                // id: coa?.userMappingid,
                schoolid:  coa.isSchool ? coa?.id : null,
                // teamid: coa.isSchool ? null : coa?.id,
                // userid: getUserInfo()?.id ?? 0,
                // active:1
              }
            } :
            {
              obj:{
                teamid: coa?.id,
                // userid: getUserInfo()?.id ?? 0,
                // active: 1
              }
            },
            resCao = await fetchGraphMethod(getSchoolTeamUserMappingForTeams, finalObj,true);
        if(resCao?.status == 200){
          const resData = resCao?.data?.data?.allSchoolteamusermappings?.Schoolteamusermappings,
              updateData = []
          resData?.length > 0 && resData.map(itm =>!!itm?.coatchid && updateData.push(itm))
          coa['totalCoa'] = updateData
          setTeamAndCoachList([...totalData]);
        }else{
          console.log("api team coach failed")
        }
      })
    }else{
      setTeamAndCoachList([])
    }
  }, [props.teamAndCoachList]);
  
  const goToCoach = (e, team) => {
    e.preventDefault();
    history.push({
      pathname: "/add-coaches",
      state: {
        schoolTeamMapping: {
          isUserMapping: true,
          userMappingid: team.userMappingid,
          isSchool: team.isSchool,
          isTeam: !team.isSchool,
          schoolid: team.isSchool ? team.id : null,
          teamid: team.isSchool ? null : team.id,
        },
      },
    });
  };
  const showMoreHandler = (value) => {
    setShowLess(!showLess);
   // let prevData = [...props.teamAndCoachList]
   //  let data = prevData?.length > 0 ? prevData?.map(item => {
   //    debugger
   //    if(value == "more"){
   //      item['totalCoa'] = [...item.totalCoa]
   //    }
   //    else if(value == "less"){
   //      item.totalCoa = item.totalCoa.splice(0,3)
   //    }
   //    return item;
   //  }) : [];
   //  setTeamAndCoachList(data);
  }
  const onDeleteHandler = (e, team) => {
    e.preventDefault();
    props.onDeleteClick(team);
  };

  const onCheckboxChangeHandler = async (e, id, isPrimary) => {
    setLoader(true);
    let teamAndCoachListT = teamAndCoachList;
    let checkedPrimary = false;
    let checkedSecondary = false;
    teamAndCoachListT.forEach((team) => {
      if (isPrimary) {
        if (team.isPrimary) {
          checkedPrimary = true;
        }
      } else {
        if (team.isSecondary) {
          checkedSecondary = true;
        }
      }
    });
    if (checkedPrimary && e.target.checked) {
      messagePopup(
        "",
        "Only one team can be selected as primary. Please uncheck and try again",
        "warning"
      );
      return;
    }
    if (checkedSecondary && e.target.checked) {
      messagePopup(
        "",
        "Only one team can be selected as Secondary. Please uncheck and try again",
        "warning"
      );
      return;
    }
    let updatedTeam = null;
    teamAndCoachListT = teamAndCoachListT.map((team) => {
      if (id == team.id) {
        let didUpdate = false;
        if (isPrimary) {
          let isprimaryT = team.isPrimary;
          team.isPrimary =
            team.isSecondary && e.target.checked ? false : e.target.checked;
          if (isprimaryT != team.isPrimary) {
            didUpdate = true;
          }
        } else {
          let issecondaryT = team.isSecondary;
          team.isSecondary =
            team.isPrimary && e.target.checked ? false : e.target.checked;
          if (issecondaryT != team.isSecondary) {
            didUpdate = true;
          }
        }
        if (didUpdate) {
          updatedTeam = team;
        }
      }
      return team;
    });
    if (!updatedTeam) {
      return;
    }
    let variables = {
      where: {
        userid: getUserInfo().id,
        active: 1,
        teamid: updatedTeam.isSchool ? null : updatedTeam.id,
        schoolid: updatedTeam.isSchool ? updatedTeam.id : null,
      },
      data: {
        primaryteamstatus: updatedTeam.isPrimary ? 1 : 0,
        secondaryteamstatus: updatedTeam.isSecondary ? 1 : 0,
      },
    };
    let res = await fetchGraphMethod(updateSchoolTeamMapping, variables, true);
    if (res && res.status == 200) {
      // messagePopup("", "Team Status updated", "success");
      toastr.success("Team Status updated", "", {
        progressBar : true,timeOut: 2000,
        closeButton: true, positionClass: "toast-top-full-width",
        showEasing: "swing", fadeIn: 40000,
        preventDuplicates: true,
      })
    } else {
      return;
    }
    setTeamAndCoachList([...teamAndCoachListT]);
    setLoader(false);
  };

  const getAllTeams = () => {
    if (teamAndCoachList) {
      return teamAndCoachList.map((team, index) => (
        <li key={index}>
          <div className="team-coaches-wrapper" style={{ marginTop: "10px" }}>
            <div className="team-coaches-top">
              <div className="team-flex-box">
                <div className="team-flex-item">
                  <div className="icon-box">
                    <img src={!!team?.teamlogo ? `${imageDownloadUrl}/${team?.teamlogo}` : coacheImg1} alt="coache Img" />
                  </div>
                  <div className="content-box" key={team.id}>
                    <h4>
                      {team.teamname ? team.teamname : team.highschoolname}
                    </h4>
                    <div className="itemCheckbox">
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          onCheckboxChangeHandler(e, team.id, true);
                        }}
                        checked={team.isPrimary}
                      />
                      <span>
                        <label htmlFor="strong">Primary</label>
                      </span>
                    </div>
                    <div className="itemCheckbox">
                      <span>
                        <input
                          type="checkbox"
                          // id=
                          onChange={(e) => {
                            onCheckboxChangeHandler(e, team.id, false);
                          }}
                          checked={team.isSecondary}
                        />

                        <label htmlFor="strong">Secondary</label>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="team-button-wrapper">
                  <a className="btn green" onClick={(e) => goToCoach(e, team)}>
                    <img src={pencilIcon} alt="pencil Icon" />
                  </a>
                  <button
                    className="btn"
                    onClick={(e) => onDeleteHandler(e, team)}
                  >
                    <img src={trashIcon} alt="trash Icon" />
                  </button>
                </div>
              </div>
            </div>
            <div className="coaches-main-wrapper">
              <ul className="coache-listing">
                {/*earlier it was coachData*/}
                {team?.totalCoa?.[0]?.schoolteamusermappingcoatchidmaprel?.Coachandteamdetails?.length > 0
                  ? team?.totalCoa?.slice(0, showLess ? 3 : team?.totalCoa?.length)?.map((coach, index) => {
                      // if (!coach.coachfirstname) {
                      //   return;
                      // }
                      return (
                        <li className="team-flex-item" key={index}>
                          <div className="icon-box">
                            <img src={coach?.schoolteamusermappingcoatchidmaprel?.Coachandteamdetails?.length > 0 ?
                                !!coach?.schoolteamusermappingcoatchidmaprel?.Coachandteamdetails?.[0]?.coachandteamdetailsonboardingidmaprel?.[0]?.Onboardings?.[0]?.profileimages ?
                                    `${imageDownloadUrl}/${coach?.schoolteamusermappingcoatchidmaprel?.Coachandteamdetails?.[0]?.coachandteamdetailsonboardingidmaprel?.[0]?.Onboardings?.[0]?.profileimages}`
                                    : coacheImg1
                                : coacheImg1} alt="coache Img" />
                          </div>
                          <div className="content-box">
                            <h4>
                              {/*{`${coach?.coachfirstname} ${coach?.coachlastname}`}{" "}*/}
                              {coach?.schoolteamusermappingcoatchidmaprel?.Coachandteamdetails[0]?.coachfirstname}
                              &nbsp;{coach?.schoolteamusermappingcoatchidmaprel?.Coachandteamdetails[0]?.coachlastname}
                            </h4>
                            <p>
                              {coach.typename}
                              {coach.typename ? " at " : ""}
                              {/*{team.teamname*/}
                              {/*  ? team.teamname*/}
                              {/*  : team.highschoolname}*/}
                            </p>
                            {/*{team.isverified }*/}
                            {team.isverified == 0 ? (
                              <div className="pending-text">
                                PENDING CONNECTION
                              </div>
                            ) : (
                              <div
                                className="pending-text"
                                style={{ color: "green" }}
                              >
                                VERIFIED CONNECTION
                              </div>
                            )}
                          </div>
                        </li>
                      );
                    })
                  : null}
              </ul>
              {team?.totalCoa?.length > 3 &&
                  <ul className="coache-listing">
                    <li className="showMoreList" onClick={() => showMoreHandler("less")}>
                      {showLess ? "Show More" : "Show Less"}
                      {showLess ?
                          <svg xmlns="http://www.w3.org/2000/svg" width="13.267" height="6.626"
                                       viewBox="0 0 13.267 6.626">
                        <defs></defs>
                        <path className="a"
                              d="M14.121,20.121a.946.946,0,0,1-.605-.218L7.84,15.174a.947.947,0,1,1,1.211-1.457l5.071,4.238,5.071-4.087a.97.97,0,1,1,1.2,1.523l-5.676,4.569A.946.946,0,0,1,14.121,20.121Z"
                              transform="translate(-7.498 -13.498)"/>
                      </svg>
                          :
                          <svg className='showLess' xmlns="http://www.w3.org/2000/svg" width="13.267" height="6.626"
                               viewBox="0 0 13.267 6.626">
                            <defs></defs>
                            <path className="a"
                                  d="M14.121,20.121a.946.946,0,0,1-.605-.218L7.84,15.174a.947.947,0,1,1,1.211-1.457l5.071,4.238,5.071-4.087a.97.97,0,1,1,1.2,1.523l-5.676,4.569A.946.946,0,0,1,14.121,20.121Z"
                                  transform="translate(-7.498 -13.498)"/>
                          </svg>
                      }
                    </li>
                  </ul>
              //     <ul className="coache-listing" >
              //   <li className="showMoreList" onClick={()=>showMoreHandler("more")}>
              //   Show More
              //   </li>
              // </ul>
              }
              <a className="link-text" onClick={(e) => goToCoach(e, team)}>
                Don't see your coach? Invite them
              </a>
            </div>
          </div>
        </li>
      ));
    } else {
      return null;
    }
  };
  return (
    <div className="editSection">
      <Title title={"Teams"} />
      <div className="check-list-sec">
        <div className="team-main-wrapper">
          <div className="team-top-block">
            <h3>Find Your Team!</h3>
            <div className="short-text">
              <p>
                Adding your team and your coaches will help improve
                <br /> your exposure and search ranking.
              </p>
              <a
                className="btn green"
                href="javascript.void(0)"
                onClick={(e) => {
                  e.preventDefault();
                  history.push({
                    pathname:"/teams/add-team",
                    previousPage: props?.props?.location?.state?.previousPage || ""
                  });
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14.75"
                  height="14.75"
                  viewBox="0 0 14.75 14.75"
                >
                  <path
                    className="a"
                    d="M18.074,10.646H13.1V5.676a1.23,1.23,0,0,0-2.458,0v4.97H5.676a1.23,1.23,0,0,0,0,2.458h4.97v4.97a1.23,1.23,0,0,0,2.458,0V13.1h4.97a1.23,1.23,0,0,0,0-2.458Z"
                    transform="translate(-4.5 -4.5)"
                  />
                </svg>
                Add Team
              </a>
            </div>
          </div>
          {getAllTeams()}
       <div className="form-button-box with-next-prev">
          <div className="next-prev-button">
          <ScreenSwitch
            prevLink={"/vitals"}
            nextLink={"/Stats"}
            isSaved={true}
          />
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

const Teams = (props) => {
  const store = useSelector(store => store)
  const [sideMenuOpen, setSideMenu] = useState(store?.athlete?.editUserProfileData?.teamSideBarStatus?.status || false),
    [showDeleteModal, setShowDeleteModal] = useState(false);
  const [teamArray, setTeamArray] = useState([]);
  const [teamAndCoachList, setTeamAndCoachList] = useState([]);
  const [teamDelete, setTeamDelete] = useState({});
  const fakeInput = useRef(null);
  const dispatch = useDispatch()
  useEffect(() => {
    fetchSchoolTeam();
    fakeInput.current.focus();
    fakeInput.current.select();
  }, []);

  const fetchSchoolTeam = () => {
    props.schoolTeamUserMappingStart({
      query: getSchoolTeamUserMappingForTeams,
      variables: {
        obj: {
          userid: getUserInfo() ? getUserInfo().id : 0,
          active: 1,
        },
      },
    });
  };


  useEffect(() => {
    if (
      props.schoolTeamUserMapping.data &&
      props.schoolTeamUserMapping.data.schoolTeamUserMapping &&
      props.schoolTeamUserMapping.data.schoolTeamUserMapping
        .Schoolteamusermappings
    ) {
      let teamArrayT = [];
      for (const school of props.schoolTeamUserMapping.data
        .schoolTeamUserMapping.Schoolteamusermappings) {
        if (
          school.schoolteamusermappingschoolidmaprel &&
          school.schoolteamusermappingschoolidmaprel.Athleteschools &&
          school.schoolteamusermappingschoolidmaprel.Athleteschools[0]
        ) {
          teamArrayT.push({
            ...school.schoolteamusermappingschoolidmaprel.Athleteschools[0],
            userMappingid: school.id,
            isSchool: true,
            createdBy: school?.createdby,
            isPrimary: school.primaryteamstatus ? true : false,
            isSecondary: school.secondaryteamstatus ? true : false,
            coach: school.schoolteamusermappingcoatchidmaprel
              ? school.schoolteamusermappingcoatchidmaprel.Coachandteamdetails
                ? school.schoolteamusermappingcoatchidmaprel
                    .Coachandteamdetails[0]
                  ? [
                      {
                        ...school.schoolteamusermappingcoatchidmaprel
                          .Coachandteamdetails[0],
                        typename: school.schoolteamusermappingcoatchidmaprel
                          .Coachandteamdetails[0]
                          .coachandteamdetailscoachtypeidmaprel
                          ? school.schoolteamusermappingcoatchidmaprel
                              .Coachandteamdetails[0]
                              .coachandteamdetailscoachtypeidmaprel
                              .Coachtypes[0]?.coachtypename
                          : null,
                      },
                    ]
                  : []
                : []
              : [],
          });
        }
        if (
          school.schoolteamusermappingteamidmaprel &&
          school.schoolteamusermappingteamidmaprel.Teams &&
          school.schoolteamusermappingteamidmaprel.Teams[0]
        ) {
          teamArrayT.push({
            ...school.schoolteamusermappingteamidmaprel.Teams[0],
            userMappingid: school.id,
            isSchool: false,
            createdBy: school?.createdby,
            isPrimary: school.primaryteamstatus ? true : false,
            isSecondary: school.secondaryteamstatus ? true : false,
            coach: school.schoolteamusermappingcoatchidmaprel
              ? school.schoolteamusermappingcoatchidmaprel.Coachandteamdetails
                ? school.schoolteamusermappingcoatchidmaprel
                    .Coachandteamdetails[0]
                  ? [
                      {
                        ...school.schoolteamusermappingcoatchidmaprel
                          .Coachandteamdetails[0],
                        typename: school.schoolteamusermappingcoatchidmaprel
                          .Coachandteamdetails[0]
                          .coachandteamdetailscoachtypeidmaprel
                          ? school.schoolteamusermappingcoatchidmaprel
                              .Coachandteamdetails[0]
                              .coachandteamdetailscoachtypeidmaprel
                              .Coachtypes[0]?.coachtypename
                          : null,
                      },
                    ]
                  : []
                : []
              : [],
          });
        }
      }

      let prevTeamData = {};
      let prevSchoolData = {};
      let finalData = [];
      for (const data of teamArrayT) {
        if (!data.isSchool) {
          if (prevTeamData[data.id]) {
            let tempData = { ...prevTeamData[data.id] };
            tempData["coach"] = [...tempData["coach"], ...data.coach];
            prevTeamData[data.id] = tempData;
          } else {
            prevTeamData[data.id] = data;
          }
        } else {
          if (prevSchoolData[data.id]) {
            let tempData = { ...prevSchoolData[data.id] };
            tempData["coach"] = [...tempData["coach"], ...data.coach];
            prevSchoolData[data.id] = tempData;
          } else {
            prevSchoolData[data.id] = data;
          }
        }
      }

      for (const [_, value] of Object.entries(prevTeamData)) {
        finalData = [...finalData, value];
      }
      for (const [_, value] of Object.entries(prevSchoolData)) {
        finalData = [...finalData, value];
      }
      finalData.sort((a, b) => {
        return b.userMappingid - a.userMappingid;
      });
      setTeamAndCoachList([...finalData]);
    }
  }, [props.schoolTeamUserMapping.data]);

  async function getCoachDetails() {
    if (teamArray) {
      let teamAndCoachListT = [];
      for (var team of teamArray) {
        let variables = { obj: {} };
        // if (team.teamname) {
          variables.obj = { teamid: team.id };
        // }
        // if (team.highschoolname) {
          variables.obj = { schoolid: team.id };
        // }
        await fetchGraphMethod(
          getSchoolTeamUserMappingForCoaches,
          variables,
          true
        )
          .then((res) => {
            let coachInfo;
            coachInfo = res.data.data;
            let TeamAndCoachDetail = { ...team, coach: [] };
            if (
              coachInfo &&
              coachInfo.allSchoolteamusermappings &&
              coachInfo.allSchoolteamusermappings.Schoolteamusermappings &&
              coachInfo.allSchoolteamusermappings.Schoolteamusermappings[0]
            ) {
              coachInfo.allSchoolteamusermappings.Schoolteamusermappings.map(
                (coach) => {
                  let coachDetail = {};
                  if (
                    coach.schoolteamusermappingcoatchidmaprel &&
                    coach.schoolteamusermappingcoatchidmaprel
                      .Coachandteamdetails &&
                    coach.schoolteamusermappingcoatchidmaprel
                      .Coachandteamdetails[0]
                  ) {
                    coachDetail.id =
                      coach.schoolteamusermappingcoatchidmaprel.Coachandteamdetails[0].id;
                    coachDetail.coachfirstname =
                      coach.schoolteamusermappingcoatchidmaprel.Coachandteamdetails[0].coachfirstname;
                    coachDetail.coachlastname =
                      coach.schoolteamusermappingcoatchidmaprel.Coachandteamdetails[0].coachlastname;
                    if (
                      coach.schoolteamusermappingcoatchidmaprel
                        .Coachandteamdetails[0]
                        .coachandteamdetailscoachtypeidmaprel &&
                      coach.schoolteamusermappingcoatchidmaprel
                        .Coachandteamdetails[0]
                        .coachandteamdetailscoachtypeidmaprel.Coachtypes[0]
                    ) {
                      coachDetail.typename =
                        coach.schoolteamusermappingcoatchidmaprel.Coachandteamdetails[0].coachandteamdetailscoachtypeidmaprel.Coachtypes[0].coachtypename;
                    }
                  }
                  TeamAndCoachDetail.coach.push(coachDetail);
                }
              );
              teamAndCoachListT.push(TeamAndCoachDetail);
            }
            teamAndCoachListT.sort((a, b) => {
              return b.userMappingid - a.userMappingid;
            });
          })
          .catch((err) => {
            messagePopup("", "Team Coach list failed", "error");
          });
      }
      setTeamAndCoachList([...teamAndCoachListT]);
    }
    if (!teamArray) {
      setTeamAndCoachList([]);
    }
  }
  const onSideMenuClick = () => {
    setSideMenu(!sideMenuOpen);
    dispatch({type:"TEAM_SIDE_BAR_START" ,payload:{status: !sideMenuOpen}})
  };
  const onDeleteClick = () => {
    setShowDeleteModal(!showDeleteModal);
  };
  const onDeleteClickHandler = (team) => {
    setTeamDelete(team);
    onDeleteClick();
  };
  const onTeamDeleteHandler = () => {
    props.deleteSchoolTeamStart({
      data: {
        // teamAndSchoolMappigId: teamDelete.userMappingid,
        // userId: getUserInfo().id,
        // teamId: teamDelete.isSchool ? 0 : teamDelete.id,
        // schoolId: teamDelete.isSchool ? teamDelete.id : 0,
        teamAndSchoolMappigId: +teamDelete?.userMappingid ?? 0,
        userId:+getUserInfo()?.id ?? 0,
        teamId:teamDelete.isSchool ? 0  : teamDelete.id,
        schoolId:teamDelete.isSchool ? teamDelete.id : 0,
        createdby: !!teamDelete?.createdBy ?
            teamDelete?.createdBy == getUserInfo()?.id ? 1 : 0
            : 0
      },
      successMsg: teamDelete.isSchool
        ? "School deleted successfully"
        : "Team deleted successfully",
      failureMsg: teamDelete.isSchool
        ? "Delete school failed"
        : "Delete team failed",
      refreshPage,
    });

    onDeleteClick();
  };

  const refreshPage = () => {
    fetchSchoolTeam();
  };

  const goTop = () => {
    fakeInput.current.focus();
    fakeInput.current.select();
  };
 //this is used for scrolling the page on top
  useEffect(()=>{
    setTimeout(()=>{
      window.scrollTo(0,0)
    },1800)
  },[])

  return (
    <div className="pageContent">
      <BackdropLoader
        open={
          props.schoolTeamUserMapping.loading || props.deleteSchoolTeam.loading
        }
      />
      <div className="editProfile">
      <input className="fakeInput" type="text" ref={fakeInput} />
        <div className="container">
          <div
            id="wrapper"
            className={`flex ${sideMenuOpen ? "inactive" : ""}`}
          >
            <SubHeader onSideMenuClick={onSideMenuClick} />
            <div className="sidebar">
              <LeftSideEditProfile />
            </div>
            <EditSection
              onDeleteClick={onDeleteClickHandler}
              teamAndCoachList={teamAndCoachList}
              props={props}
            />
          </div>
          <GoTopButton goTop={goTop} />
        </div>
      </div>
      <Dialog open={showDeleteModal}
              onClose={(event, reason)=> {
                if (reason == "backdropClick" || reason == "escapeKeyDown") {
                  onDeleteClick()
                }
              }}
              className="matDialogCustom"
      >
        <DeleteItem
          onDeleteClick={onTeamDeleteHandler}
          onCancelClick={onDeleteClick}
          team={teamDelete}
        />
      </Dialog>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    schoolTeamUserMapping:
      state.athlete.editUserProfileData.schoolTeamUserMapping,
    deleteSchoolTeam: state.athlete.editUserProfileData.deleteSchoolTeam,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    schoolTeamUserMappingStart: (data) =>
      dispatch(schoolTeamUserMappingStart(data)),
    schoolTeamUserMappingSave: (data) =>
      dispatch(schoolTeamUserMappingSave(data)),
    deleteSchoolTeamStart: (data) => dispatch(deleteSchoolTeamStart(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Teams);
